import React from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import CakeIcon from "@mui/icons-material/Cake";
import WcIcon from "@mui/icons-material/Wc";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SettingsIcon from "@mui/icons-material/Settings";

import "./styles/Profile.css";

/* ── small read-only field ────────────────────────────── */
const Field = ({ label, icon, value }) => (
  <div className="prof-field prof-field--half">
    <label className="prof-label">
      <span className="prof-label-icon">{icon}</span>
      {label}
    </label>
    <div className="prof-value">
      {value || <span className="prof-empty">Not provided</span>}
    </div>
  </div>
);

const FullField = ({ label, icon, value }) => (
  <div className="prof-field">
    <label className="prof-label">
      <span className="prof-label-icon">{icon}</span>
      {label}
    </label>
    <div className="prof-value">
      {value || <span className="prof-empty">Not provided</span>}
    </div>
  </div>
);

const Profile = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const addr = user?.address || {};

  return (
    <div>
      {/* HEADER */}
      <div className="dash-page-header">
        <h1 className="dash-page-title">
          My <span>Profile</span>
        </h1>
        <p className="dash-page-sub">
          Your account information — edit from Settings
        </p>
      </div>

      <div className="prof-grid">
        {/* ── LEFT: Avatar card ──────────────────────── */}
        <div className="prof-avatar-card">
          <div className="prof-avatar-circle">
            {user?.avatar ? (
              <img src={user.avatar} alt="avatar" />
            ) : (
              <span>
                {user?.name?.charAt(0)?.toUpperCase() || "U"}
              </span>
            )}
          </div>

          <div>
            <div className="prof-avatar-name">
              {user?.name || "User"}
            </div>
            <div className="prof-avatar-email">
              {user?.email || "No email"}
            </div>
            <div className="prof-avatar-badge">VERIFIED ACCOUNT</div>
          </div>

          {/* Settings shortcut */}
          <button
            className="prof-settings-link"
            onClick={() => navigate("/dashboard/settings")}
          >
            <SettingsIcon style={{ fontSize: 15 }} />
            Edit in Settings
          </button>
        </div>

        {/* ── RIGHT: Info card ───────────────────────── */}
        <div className="prof-info-card">
          {/* Personal */}
          <div className="prof-card-header">
            <div className="prof-card-title">Personal Information</div>
            <button
              className="prof-edit-btn"
              onClick={() => navigate("/dashboard/settings")}
            >
              <SettingsIcon style={{ fontSize: 14 }} />
              Edit in Settings
            </button>
          </div>

          <div className="prof-fields">
            <Field
              label="Full Name"
              icon={<PersonIcon />}
              value={user?.name}
            />
            <Field
              label="Email Address"
              icon={<EmailIcon />}
              value={user?.email}
            />
            <Field
              label="Phone Number"
              icon={<PhoneIcon />}
              value={user?.phone}
            />
            <Field
              label="Date of Birth"
              icon={<CakeIcon />}
              value={user?.dob}
            />
            <Field
              label="Age"
              icon={<PersonIcon />}
              value={user?.age}
            />
            <Field
              label="Gender"
              icon={<WcIcon />}
              value={user?.gender}
            />
          </div>

          {/* Divider */}
          <div className="prof-section-divider" />

          {/* Address */}
          <div className="prof-card-header prof-card-header--mt">
            <div className="prof-card-title">Delivery Address</div>
          </div>

          <div className="prof-fields">
            <FullField
              label="Address Line 1"
              icon={<LocationOnIcon />}
              value={addr.line1}
            />
            <FullField
              label="Address Line 2"
              icon={<LocationOnIcon />}
              value={addr.line2}
            />
            <Field label="City" icon={<LocationOnIcon />} value={addr.city} />
            <Field label="District" icon={<LocationOnIcon />} value={addr.district} />
            <Field label="State" icon={<LocationOnIcon />} value={addr.state} />
            <Field label="Pincode" icon={<LocationOnIcon />} value={addr.pincode} />
            <Field label="Country" icon={<LocationOnIcon />} value={addr.country} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;